import * as types from '../../mutationTypes';

export default {
    /* eslint-disable no-param-reassign */
    [types.RESET_SESSION](state) {
        state.idpUri = '';
        state.redirectUri = '';
        state.fqdn = '';
        state.subdomain = '';
        state.role = 0;
        state.tokenExpiry = 0;
        state.refreshToken = false;
        state.interruptRefreshToken = false;
        state.siteType = 0;
    },

    [types.SET_SUBDOMAIN](state, value) {
        state.subdomain = value;
    },

    [types.SET_IDP_URI](state, value) {
        state.idpUri = value;
    },

    [types.SET_FQDN](state, value) {
        state.fqdn = value;
    },

    [types.SET_REDIRECT_URI](state, value) {
        state.redirectUri = value;
    },

    [types.SET_ROLE](state, value) {
        let role = value;
        // if (typeof value !== 'number') role = 1;
        if (isNaN(value)) role = 1;
        state.role = role;
    },

    [types.SET_REFRESH_TOKEN](state, value) {
        state.refreshToken = value;
    },

    [types.SET_INTERRUPT_REFRESH_TOKEN](state, value) {
        state.interruptRefreshToken = value;
    },

    [types.SET_TOKEN_EXPIRY](state, value) {
        let tokenExpiry = value;
        // if (typeof value !== 'number') role = 1;
        if (isNaN(value)) tokenExpiry = 0;
        state.tokenExpiry = tokenExpiry;
    },

    [types.SET_SITE_TYPE](state, value) {
        state.siteType = value;
    }

    /* eslint-enable no-param-reassign */
};



// WEBPACK FOOTER //
// ./src/store/modules/session/mutations.js